import * as React from 'react';

import { trackEvent } from '@/analytics/trackEvent';
import { useIsSettings } from '@/hooks/useIsSettings';
import type { People } from '@/types';

import { useEditContact } from './queries/useEditContact';

export const usePriority = (people: People) => {
  const [priority, setPriority] = React.useState(people.people_priority);
  const editContact = useEditContact();
  const isSettings = useIsSettings();

  const firstRender = React.useRef(true);

  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    setPriority(people.people_priority);
  }, [people]);

  const changeHandler = React.useCallback(
    async (priority: string) => {
      setPriority(priority);
      trackEvent('priority', {
        priority,
        path: isSettings ? 'manage_contacts' : 'feed',
      });
      await editContact.mutateAsync(
        {
          people_id: people.people_id,
          people_name: people.people_name,
          people_priority: priority,
        },
        {
          onError: () => {
            setPriority(people.people_priority);
          },
        }
      );
    },
    [editContact, isSettings, people]
  );

  return { priority, changeHandler };
};
